import React from 'react';
import InfoPage from './info/InfoPage';

export default function Main() {
  return <InfoPage />;
}
